import React from 'react'
import passportActivationImage from '../../assets/img/passport-activation-image.webp'

export const getActivationContent = (stationTitle, email) => ({
  title: (
    <span>
      Thank you for supporting
      <br />
      {stationTitle}!
    </span>
  ),
  description: (
    <span>
      Your receipt has been emailed to <b>{email}</b>. To access {stationTitle}{' '}
      Passport content on any device, sign in using this account.
      <br />
      <br />
      By activating your member benefit, you are accepting that PBS and your
      station may share your viewing history with each other and their service
      providers.
    </span>
  ),
  image: passportActivationImage,
  imageTitle: 'Look for the Passport symbol on videos.',
  tts: `Thank you for supporting ${stationTitle} ..... Your receipt has been emailed to ${email}. To access ${stationTitle} Passport content on any device, sign in using this account ..... By activating your member benefit, you are accepting that PBS and your station may share your viewing history with each other and their service providers.`,
})

export const getDeclineConfirmationContent = (stationTitle) => ({
  title: <span>Confirmation Needed</span>,
  description: (
    <span>
      We&#39;re sorry, but if you do not confirm, you cannot access your
      station&#39;s Passport benefit.
      <br />
      <br />
      If you do not agree to allow PBS and your station to share your viewing
      history with each other and their service providers, you can contact{' '}
      {stationTitle} Passport Support to cancel.
    </span>
  ),
  tts: `Confirmation Needed ..... We're sorry, but if you do not confirm, you cannot access your station's Passport benefit. ..... If you do not agree to allow PBS and your station to share your viewing history with each other and their service providers, you can contact ${stationTitle} Passport Support to cancel`,
})

export const getMoreInformationContent = (stationTitle) => ({
  title: <span>Confirmation Needed</span>,
  description: (
    <span>
      With {stationTitle} Passport, you get extended, on-demand access to 1,500+
      episodes of your favorite PBS shows and local programs.
      <br />
      <br />
      By activating this member benefit, you are accepting that PBS and your
      station may share your viewing history with each other and their service
      providers.
      <br />
      <br />
      If you do not accept, you cannot access your station&#39;s Passport
      Benefit.
    </span>
  ),
  tts: `Confirmation Needed ..... With ${stationTitle} Passport, you get extended, on-demand access to 1,500+ episodes of your favorite PBS shows and local programs. By activating this member benefit, you are accepting that PBS and your station may share your viewing history with each other and their service providers. If you do not accept, you cannot access your station's Passport Benefit.`,
})
